module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Bold-039c1f6c058416bddb55f95fba7733f1.woff2";